import React, { memo, useEffect } from 'react';

import { useAppContext } from 'app/lib/AppContext';
import { IPageEnd } from 'app/store/nodes/card/interfaces';

import DownloadAndroid from './DownloadAndroid';
import DownloadIOS from './DownloadIOS';
import DownloadDesktop from './DownloadDesktop';

const showAF = (osName: string, platformType: string) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  let container = document.body.querySelector('#appsflyer-banner-container');
  if (container) {
    return;
  }
  const AF = (window as any)?.AF;
  if (typeof AF === 'undefined') {
    return;
  }
  container = (document.createElement('div') as HTMLDivElement);
  container.setAttribute('id', 'appsflyer-banner-container');
  document.body.appendChild(container);
  setTimeout(() => {
    AF('banners', 'showBanner', {
      bannerContainerQuery: '#appsflyer-banner-container',
      additionalParams: {
        Os: osName,
        DeviceType: platformType,
      },
    });
  }, 1000);
};

interface IDownload {
  data: IPageEnd,
  isHoliday: boolean,
}

const Download: React.FC<IDownload> = memo((props) => {
  const { bowser } = useAppContext();

  useEffect(() => {
    if (bowser?.platform?.type === 'mobile') {
      showAF(bowser?.os?.name || 'unknown', bowser?.platform?.type || 'unknown');
    }
  }, [bowser?.os?.name, bowser?.platform?.type]);

  if (String(bowser?.os?.name).toLowerCase() === 'android') {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <DownloadAndroid {...props} />;
  }

  if (String(bowser?.os?.name).toLowerCase() === 'ios') {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <DownloadIOS {...props} />;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <DownloadDesktop {...props} />;
});

export default Download;
